'use client';

export const GlobalStyle = () => {
  return (
    <style id="antiClickjack" jsx>
      {`
        body {
          display: none;
        }
      `}
    </style>
  );
};
